import { Activity, Github, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <div className="h-9 w-9 rounded-xl bg-slate-900 flex items-center justify-center">
                <Activity className="h-4 w-4 text-sky-200" strokeWidth={2.5} />
              </div>
              <div>
                <div className="font-heading text-base font-semibold tracking-tight text-slate-900">
                  Shushrut<span className="text-sky-500">.</span>AI
                </div>
                <div className="text-[9px] uppercase tracking-[0.25em] text-slate-400 font-mono-num">
                  Dermatology · Multi-agent
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-600 max-w-md leading-relaxed">
              A research-first dermatology assistant built by students and
              clinicians. Not a substitute for a licensed medical opinion.
            </p>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] font-mono-num text-slate-400">Team</div>
            <ul className="mt-4 space-y-1.5 text-sm text-slate-700">
              <li>Principal Investigator</li>
              <li>ML Engineering</li>
              <li>Clinical Advisors</li>
              <li>Design & Product</li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] font-mono-num text-slate-400">Contact</div>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-700">
              <li className="flex items-center gap-2 group">
                <Mail className="h-4 w-4 text-slate-400 group-hover:text-sky-500 transition-colors" />
                <a 
                  href="mailto:team@shushrut.ai" 
                  className="hover:text-sky-600 transition-colors cursor-pointer"
                  data-testid="footer-email"
                >
                  team@shushrut.ai
                </a>
              </li>
              <li className="flex items-center gap-2 group">
                <Github className="h-4 w-4 text-slate-400 group-hover:text-sky-500 transition-colors" />
                <a 
                  href="https://github.com/shushrut-ai" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-sky-600 transition-colors cursor-pointer" 
                  data-testid="footer-github"
                >
                  github.com/shushrut-ai
                </a>
              </li>
            </ul>
            <div className="mt-6 text-[10px] uppercase tracking-[0.25em] font-mono-num text-slate-400">
              Institution
            </div>
            <div className="mt-2 text-sm text-slate-700">Shushrut Institute of Technology</div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-slate-100 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 text-xs text-slate-500 font-mono-num tracking-wider">
          <div>© {new Date().getFullYear()} Shushrut AI · Research Preview</div>
          <div>v1.0 · build 2026.02</div>
        </div>
      </div>
    </footer>
  );
}
